// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"easy-language-module--wrapper--zh1kL"};